define(['swiper/js/swiper-bundle.min'], function (Swiper) {
    const swiperStartPage = new Swiper('.swiper-start-page', {
        observer: true,
        observeParents: true,
        edgeSwipeDetection: 'prevent',
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        grabCursor: true,
        mousewheel: true,
        cssMode: true,
        navigation: {
            nextEl: '.swiper-start-page-button-next',
            prevEl: '.swiper-start-page-button-prev',
        },
    });
    return swiperStartPage;
});
